import React, { useContext, useEffect, useState } from "react";
import './NewsArticle.scss';
import { getDate } from "../../utilities/convertToDate";
import { MyContext } from "../../CustomContext";
// import { BackgroundImage } from "react-image-and-background-image-fade";
import { motion } from "framer-motion";

const NewsArticle = ({ article, bookmarkMsgHandler }) => {
    const [isBookmark, setIsBookmark] = useState(false);
    const [imageError, setImageError] = useState(false);

    const myContext = useContext(MyContext);
    const { language, isMobileDevice, hideHeader, setHideHeader, windowHeight, articles, hindiBookmarkArticles, setHindiBookmarkArticles, englishBookmarkArticles, setEnglishBookmarkArticles } = myContext;

    const { hours, minutes, meridiem, day, date, month, year } = getDate(article.publishedAt);

    const articleHandler = () => {
        if (isMobileDevice)
            setHideHeader(!hideHeader);
    }

    const bookmarksHandler = (e) => {
        e.stopPropagation();

        if (isBookmark) { //bookmark removed
            setIsBookmark(false);
            bookmarkMsgHandler("Bookmark Removed");

            let updatedBookmarksArticles;

            if (language === 'hi') {
                updatedBookmarksArticles = hindiBookmarkArticles.filter((eachArticle) => {
                    return eachArticle.title !== article.title;
                });

                setHindiBookmarkArticles(updatedBookmarksArticles);
            }
            else {
                updatedBookmarksArticles = englishBookmarkArticles.filter((eachArticle) => {
                    return eachArticle.title !== article.title;
                });

                setEnglishBookmarkArticles(updatedBookmarksArticles);
            }
        }
        else { // bookmark added
            setIsBookmark(true);
            bookmarkMsgHandler("News Bookmarked");

            if (language === 'hi') {
                setHindiBookmarkArticles([...hindiBookmarkArticles, article]);
            }
            else {
                setEnglishBookmarkArticles([...englishBookmarkArticles, article]);
            }
        }
    }

    // the same component is reused for another article (key is index), so give the new image a fresh try
    useEffect(() => {
        setImageError(false);
    }, [article.image])

    useEffect(() => {
        if (language === 'hi') {
            const isArticleBookmarked = hindiBookmarkArticles.filter((eachArticle) => {
                return eachArticle.title === article.title;
            }).length;

            setIsBookmark(isArticleBookmarked > 0);
        }
        else {
            const isArticleBookmarked = englishBookmarkArticles.filter((eachArticle) => {
                return eachArticle.title === article.title;
            }).length;

            setIsBookmark(isArticleBookmarked > 0);
        }
    }, [articles, language, hindiBookmarkArticles, englishBookmarkArticles, article.title])

    return (
        <div className={`news-article ${isMobileDevice && "mobile-news-article"}`} onClick={articleHandler} style={{ height: isMobileDevice && windowHeight }}>
            {/* <BackgroundImage
                className={"article-image"}
                src={article.image}
                lazyLoad
            /> */}

            {
                article.image && !imageError ?
                    <motion.img
                        className={"article-image"}
                        src={article.image}
                        alt={article.title}
                        onError={() => setImageError(true)}
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.8 }}
                    />
                    :
                    // broken or missing image url
                    <div className="article-image image-fallback">
                        <img src={`${process.env.PUBLIC_URL}/icon192x192.png`} alt="inshorts" />
                    </div>
            }

            <div className="content">
                {
                    isMobileDevice ?
                        <span className={`title ${isBookmark && 'bookmark-article'}`} onClick={bookmarksHandler}>{article.title}</span>
                        :
                        <a className={`title`} href={article.url} target="_blank" rel="noreferrer">{article.title}</a>
                }
                <span className="author-time"><b>short</b> by {article.source.name} / {`${hours}:${minutes} ${meridiem} on ${day}, ${date} ${month}, ${year}`}</span>
                <p className="description">{article.description}</p>
                <span className="source">read more at <a href={article.url} target="_blank" rel="noreferrer" className="name">{article.source.name}</a></span>
            </div>

            {isMobileDevice && <div className="bottom-section">

                <section>
                    <span>To see the full image</span><br />
                    <a href={article.image} target="_blank" rel="noreferrer" className="image-link">Tap here</a>
                </section>

                <section className={`bookmark ${isBookmark && 'bookmark-article'}`} onClick={bookmarksHandler}>
                    {isBookmark ? <i className="fa-solid fa-bookmark"></i> : <i className="fa-regular fa-bookmark"></i>}
                    <span>{language === 'hi' ? 'बुकमार्क' : 'Bookmark'}</span>
                </section>

            </div>}
        </div>
    )
}

export default NewsArticle;